import React from 'react';

function TopAppBar({ userEmail }) {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white/75 backdrop-blur-3xl border-b border-outline-variant/10">
      <div className="flex items-center justify-between px-5 h-16 safe-area-top">
        {/* Profile + Branding */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-sm font-bold">
            {userEmail ? userEmail[0].toUpperCase() : 'C'}
          </div>
          <span className="text-lg font-bold text-on-surface tracking-tight">Cunjoos</span>
        </div>

        {/* Notifications */}
        <button className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-surface-container transition-colors">
          <span className="material-symbols-outlined text-on-surface-variant text-[20px]">notifications</span>
        </button>
      </div>
    </header>
  );
}

export default TopAppBar;
